import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import isNoResponse from "../../app/shared/type-guards/is-no-response";
import { RootState } from "../../app/store";

const emptySplitApi = createApi({
  reducerPath: "api",
  tagTypes: [
    "Exam",
    "Eligibility",
    "ExamCapacity",
    "User",
    "Country",
    "CountrySubdivision",
    "ChatIdleTime",
    "TimeZone",
    "Notification",
    "Keyboard",
    "Proctor",
    "ProctorGroup",
    "ProctorAlertConfiguration",
    "UniversalHoursOfOperation",
    "TestingCenter",
    "Business",
    "Region",
    "State",
    "City",
    "Koala",
    "EligibilityMessages",
    "GovernmentID",
  ],
  baseQuery: fetchBaseQuery({
    baseUrl: "/",
    credentials: "include",
    validateStatus(response, body) {
      const isSuccessfulStatus = is2xxLevel(response.status);
      if (isNoResponse(body)) {
        return isSuccessfulStatus && body.responseCode.startsWith("S");
      }
      return isSuccessfulStatus;
    },
    prepareHeaders: (headers, { getState }) => {
      const { token } = getState() as RootState;
      if (token) {
        headers.set("X-Auth-Token", token);
      }
      return headers;
    },
    headers: {
      Accept: "application/json",
    },
  }),
  endpoints: () => ({}),
});

export default emptySplitApi;

function is2xxLevel(status: number) {
  return status >= 200 && status < 300;
}
